import { render, staticRenderFns } from "./gjsz_4.vue?vue&type=template&id=7107c5a3&scoped=true&"
import script from "./gjsz_4.vue?vue&type=script&lang=js&"
export * from "./gjsz_4.vue?vue&type=script&lang=js&"
import style0 from "./gjsz_4.vue?vue&type=style&index=0&id=7107c5a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7107c5a3",
  null
  
)

export default component.exports